import cx from "classnames";

import Box, { BoxProps } from "ds/components/Box";

import styles from "./styles.module.css";

type SectionContentProps = {
  gap?: BoxProps["gap"];
  fullbleed?: boolean;
} & BoxProps;

const SectionContent = ({ children, gap, fullbleed, ...restBoxProps }: SectionContentProps) => (
  <Box
    className={cx(styles.content, fullbleed && styles.fullbleed)}
    direction="column"
    gap={gap}
    {...restBoxProps}
  >
    {children}
  </Box>
);

SectionContent.displayName = "DS.Section.Content";

export default SectionContent;
